import { render, staticRenderFns } from "./montatura.vue?vue&type=template&id=ac85d2ca&"
import script from "./montatura.vue?vue&type=script&lang=js&"
export * from "./montatura.vue?vue&type=script&lang=js&"
import style0 from "./montatura.vue?vue&type=style&index=0&id=ac85d2ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports